<script lang="ts">
  type Props =
    & {
      type?: "success" | "warning" | "error";
      outset?: boolean;
    }
    & ({
      text?: undefined;
      children: () => any;
    } | {
      text: string;
      children?: undefined;
    });
  const { type = "success", outset = false, children, text }: Props =
    $props();
</script>

<div
  class={`
    whitespace-nowrap text-opacity-100 border-[1px] rounded-[15px] font-bold text-xs py-1 px-2 h-fit max-w-min
    ${type === "success" && "bg-greenGrey-5 text-green-75 border-green-75"}
    ${type === "warning" && "bg-orange-10 text-error-bg border-error-bg"}
    ${type === "error" && "bg-error-fg text-error-bg border-error-bg"}
  `}
  class:outset
  class:bg-greenGrey-10={type === "success"}
>
  {#if text}
    {text}
  {/if}

  {#if children}
    {@render children()}
  {/if}
</div>
